import LabeledTitle from '../../../components/LabeledTitle'
import React from 'react'
import CourtCase from './CourtCase'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'

export default function OtherCases({ data }: { data: any }) {
  return (
    <>
      <LabeledTitle title={'其他案件检测'} />
      <ExpandableListWrapper
        isEmpty={(data?.court_case_info?.other ?? []).length === 0 || data?.court_case_info?.other === undefined}
      >
        {(data?.court_case_info?.other ?? []).map((item: any, index: number) => {
          return <CourtCase number={index + 1} key={index} item={item} />
        })}
      </ExpandableListWrapper>
    </>
  )
}
